import { Controller } from "stimulus";

const SWIPE_THRESHOLD = 40; // min horizontal distance (px) to trigger
const SWIPE_MAX_VERT  = 80; // max vertical drift (px) to still count as horizontal

export default class extends Controller {
  static targets = ["panel", "overlay", "hamburgerBtn"];

  connect() {
    this._onKeydown    = (e) => { if (e.key === "Escape") this.close(); };
    this._onTurboVisit = () => this.close();
    document.addEventListener("keydown",    this._onKeydown);
    document.addEventListener("turbo:visit", this._onTurboVisit);

    this._onTouchStart = this._touchStart.bind(this);
    this._onTouchEnd   = this._touchEnd.bind(this);
    document.addEventListener("touchstart", this._onTouchStart, { passive: true });
    document.addEventListener("touchend",   this._onTouchEnd,   { passive: true });
  }

  disconnect() {
    document.removeEventListener("keydown",    this._onKeydown);
    document.removeEventListener("turbo:visit", this._onTurboVisit);
    document.removeEventListener("touchstart", this._onTouchStart);
    document.removeEventListener("touchend",   this._onTouchEnd);
  }

  // ── Public actions ────────────────────────────────────────────────────────

  open() {
    this.panelTarget.classList.add("is-open");
    this.overlayTarget.classList.add("is-visible");
    document.body.classList.add("overflow-hidden");
    if (this.hasHamburgerBtnTarget)
      this.hamburgerBtnTarget.setAttribute("aria-expanded", "true");
    this.panelTarget.focus();
  }

  close() {
    this.panelTarget.classList.remove("is-open");
    this.overlayTarget.classList.remove("is-visible");
    document.body.classList.remove("overflow-hidden");
    if (this.hasHamburgerBtnTarget)
      this.hamburgerBtnTarget.setAttribute("aria-expanded", "false");
  }

  // ── Touch gesture ─────────────────────────────────────────────────────────

  _touchStart(e) {
    const t = e.changedTouches[0];
    this._touchStartX = t.clientX;
    this._touchStartY = t.clientY;
  }

  _touchEnd(e) {
    if (this._touchStartX === undefined) return;

    const t    = e.changedTouches[0];
    const dx   = t.clientX - this._touchStartX;
    const dy   = Math.abs(t.clientY - this._touchStartY);

    this._touchStartX = undefined;

    // Ignore mostly-vertical swipes
    if (dy > SWIPE_MAX_VERT) return;

    const isOpen = this.panelTarget.classList.contains("is-open");

    // Swipe right-to-left (dx < 0) anywhere on screen → open
    if (!isOpen && dx < -SWIPE_THRESHOLD) {
      this.open();
      return;
    }

    // Swipe left-to-right (dx > 0) while drawer is open → close
    if (isOpen && dx > SWIPE_THRESHOLD) {
      this.close();
    }
  }
}
